export default __webpack_public_path__ + "static/media/comm-reconciliation-664x830-gem.83fa6953.jpg";